import React from "react";
import { Menu } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../../context/AuthContext";
import { useLayout } from "../../../context/LayoutContext";
import { Badge } from "../../ui/badge";

const titleMap = {
  "/dashboard": "Dashboard",
  "/professors": "Professor",
  "/doctors": "Doctor",
  "/trusty": "Trustees",
  "/ceo": "CEO",
  "/dean": "Dean",
  "/deal": "Dean",
  "/medical-superintendent": "Medical Superintendent",
  "/dysm": "Dysm",
  "/reports": "Reports",
  "/profile": "My Profile",
  "/settings": "Settings"
};

export default function Navbar() {
  const { toggleSidebar } = useLayout();
  const { user } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();

  const pageTitle =
    Object.entries(titleMap).find(([path]) => location.pathname.startsWith(path))?.[1] || "Overview";

  const initials = `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`.toUpperCase() || "SM";

  return (
    <header className="mx-4 mt-4 flex h-[76px] items-center justify-between rounded-[30px] border border-white/70 bg-white/78 px-4 shadow-shell backdrop-blur-xl md:mx-0 md:mt-0 md:px-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={toggleSidebar}
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl text-panel-muted transition-colors hover:bg-slate-100 hover:text-panel-ink"
        >
          <Menu className="h-6 w-6" />
        </button>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-primary">Medical Admin</p>
          <h1 className="text-lg font-bold text-panel-ink md:text-2xl">{pageTitle}</h1>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div
          className="flex cursor-pointer items-center gap-3 rounded-2xl bg-slate-50/80 px-3 py-2 transition-colors hover:bg-white"
          onClick={() => navigate("/profile")}
        >
          <div className="hidden text-right sm:block">
            <p className="text-sm font-bold capitalize text-panel-ink">
              {user?.first_name || "SPMCRC"} {user?.last_name || "Admin"}
            </p>
            <Badge className="mt-1 capitalize">{user?.role || "admin"}</Badge>
          </div>
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-panel-ink to-primary text-sm font-bold text-white">
            {initials}
          </div>
        </div>
      </div>
    </header>
  );
}
